import { render, staticRenderFns } from "./breathmeterdata.vue?vue&type=template&id=41638f8a&"
import script from "./breathmeterdata.vue?vue&type=script&lang=js&"
export * from "./breathmeterdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports